import tradeSettingsStore from "@/store/tradeSettingsStore";

// LQC-1301 — single source of truth for opening/closing the left-rail Trade
// Settings panel (TradeSettingsSidebarContent) targeted at a specific trade.
// Shared by the blotter settings cog (TradeWideSettingsCellRenderer) and the
// ES-level right-click "Toggle Settings" context menu item so both behave
// identically: clicking again on the same trade closes the panel, otherwise it
// (re)targets the panel to this row and opens it.
export const TRADE_SETTINGS_TOOL_PANEL_ID = "tradeSettings";

interface ItoggleTradeSettingsPanel {
  api: any;
  cryptoID: string | undefined;
  esid: string | undefined;
}

export function toggleTradeSettingsPanel({
  api,
  cryptoID,
  esid,
}: ItoggleTradeSettingsPanel): void {
  if (!esid) return;

  const panelOpen =
    api?.getOpenedToolPanel?.() === TRADE_SETTINGS_TOOL_PANEL_ID;
  const showingThisTrade = cryptoID
    ? tradeSettingsStore.getState().panelSelectedEsidByCryptoId[cryptoID] ===
      esid
    : false;

  // Already open on this exact trade → toggling again closes it.
  if (panelOpen && showingThisTrade) {
    api?.closeToolPanel?.();
    return;
  }

  if (cryptoID) {
    tradeSettingsStore.getState().setPanelSelectedEsid(cryptoID, esid);
  }
  // AG Grid v31: opens the tool panel and makes the sidebar visible. The store
  // update above (re)targets the panel to this trade, so this works whether the
  // panel was closed or already open on another trade.
  api?.openToolPanel?.(TRADE_SETTINGS_TOOL_PANEL_ID);
}
